// extracted by mini-css-extract-plugin
export var deleteModal = "_qp-0";